import store from '../store';
import { Logger } from 'react-logger-lib';

export const isVisible = (title, systemConfig) => {
  Logger.of('App.utils.isVisible').info(
    'Checking if title ' +
      title +
      ' is visible' +
      ' with systemConfig ' +
      JSON.stringify(systemConfig)
  );
  const { selected } = store.getState().entities;

  if (
    !selected ||
    !systemConfig ||
    !selected.name ||
    !systemConfig[selected.name]
  ) {
    return true;
  }

  const entityName = selected.name;

  const matchingAlgorithm = systemConfig[entityName].matchingAlgorithmName;

  const singleBestRecordService =
    systemConfig[entityName].singleBestRecordService;

  if (
    title === 'Review Probable Links' &&
    matchingAlgorithm !== 'Probabilistic Matching Algorithm'
  ) {
    return false;
  }

  if (
    title === 'Single Best Record' &&
    (!singleBestRecordService || singleBestRecordService === 'disabled')
  ) {
    return false;
  }
  return true;
};

// Returns true if the user has any of the permissions
// listed in the permissions parameter.
// If the list of permissions is undefined or empty,
// then the user has access
//
export const canAccessRoute = (route, permissions) => {
  const { loggedIn, user } = store.getState().session;

  if (!permissions || permissions.length === 0) {
    return true;
  }

  if (!loggedIn) {
    return false;
  }

  for (let required of permissions) {
    const hasAccess = checkHasRequiredPermission(user.permissions, required);
    if (hasAccess) {
      Logger.of('App.utils.canAccessRoute').info(
        'User  <' +
          user.username +
          '> does have required permission <' +
          required +
          '> for route ' +
          route
      );
      return true;
    }
    return false;
  }
};

const checkHasRequiredPermission = (perms, required) => {
  for (let perm of perms) {
    Logger.of('App.utils.checkHasRequiredPermission').trace(
      'Check if permission <' +
        perm.name +
        '> matches required permission <' +
        required +
        '>'
    );
    if (perm.name === required) {
      return true;
    }
  }
  return false;
};

export const hasPermission = permission => {
  const { loggedIn, user } = store.getState().session;

  if (!permission) {
    return true;
  }

  if (!loggedIn) {
    return false;
  }

  const hasAccess = checkHasRequiredPermission(user.permissions, permission);
  if (hasAccess) {
    Logger.of('App.utils.hasPermission').trace(
      'User  <' +
        user.username +
        '> does have required permission <' +
        permission +
        '>'
    );
    return true;
  }
  return false;
};

export const notHasPermission = permission => !hasPermission(permission);
